import { render, staticRenderFns } from "./ContactCallWhatsapp.vue?vue&type=template&id=f2229d3e&scoped=true&"
import script from "./ContactCallWhatsapp.vue?vue&type=script&lang=ts&"
export * from "./ContactCallWhatsapp.vue?vue&type=script&lang=ts&"
import style0 from "./ContactCallWhatsapp.vue?vue&type=style&index=0&id=f2229d3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2229d3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VIcon,VTooltip})
